<template>
    <Modal :show-footer="false" :show-title="false" @cancel="close">
        <div class="suspended-modal">
            <div class="suspended-modal-title">
                <span class="material-icons alert-icon">notification_important</span>
                Hizmetiniz Askıya Alındı
            </div>
            <div class="suspended-modal-description">
                <div class="suspended-modal-description-content">
                    Fatura döneminiz sona erdiği için hizmetiniz geçici olarak askıya alınmıştır. Tekrar erişim sağlamak için lütfen gecikmiş ödemenizi tamamlayın.

                    <div style="color: #ff4d4d; margin: 15px 0; font-weight: bold;">
                        Ödeme süresi: 7 günü aştı
                    </div>
                </div>
            </div>
            <div class="suspended-modal-footer">
                <SupsisButton
                    @click="confirm"
                    primary
                    style="width: 200px;"
                >
                    Ödeme Yap
                </SupsisButton>
                <div style="margin-top: 15px; font-size: 12px; color: #666;">
                    Not: Faturayı ödedikten sonra hizmetleriniz otomatik olarak aktif hale gelecektir.
                </div>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../../components/common/Modal2.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

export default {
    name: "SuspendedModal",
    components: {
        SupsisButton,
        Modal,
    },
    methods: {
        close() {
            this.$emit("cancel");
        },
        confirm() {
            this.$router.push("/settings/billing");
            this.$emit("cancel");
        },
    },
};
</script>
<style lang="scss" scoped>
.suspended-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    .alert-icon {
        font-size: 42px;
        color: rgb(250, 102, 102);
    }

    &-title {
        font-size: medium;
        text-align: center;
        font-weight: bold;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    &-description {
        display: flex;
        flex-direction: column;
        gap: 10px;
        text-align: center;

        &-content {
            font-size: 14px;
            font-weight: 300;
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
    }

    &-footer {
        display: flex;
        flex-direction: column;
        gap: 15px;
        align-items: center;
    }
}
</style>
